import { oneOfType, node, number, string, func } from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../common";
import * as style from "./styles.module.scss";

const Status = ({ status }) => {
  const attributesForStatus = {
    1: {
      style: style.onboarding__todo,
      label: "To do",
    },
    2: {
      style: style.onboarding__done,
      label: "Done",
    },
  };

  return (
    <div
      className={`${style.onboarding__status} ${attributesForStatus[status].style} mr-0 mr-md-1`}
    >
      {attributesForStatus[status].label}
    </div>
  );
};

Status.propTypes = {
  status: number,
};

const DrivingTestListItem = ({
  url,
  title,
  btnText,
  subtitle,
  status,
  downloadPDFFile,
}) => {
  const isDone = status === 2;
  return (
    <li className={`${style.onboarding__wrapper} flex-column flex-sm-row`}>
      <div className="d-flex align-items-center justify-content-between justify-content-md-start flex-grow-1 w-100">
        {status && <Status status={status} />}
        <div className="d-flex flex-column">
          <h6 className="mb-0">{title}</h6>
          {subtitle && (
            <p className="fontSize-13 mt-hf mb-0 text-prewrap">{subtitle}</p>
          )}
        </div>
      </div>
      {isDone && downloadPDFFile && (
        <Button
          classes={`btn btn-primary ml-sm-1 mt-hf mt-sm-0 ${style.onboarding__btn}`}
          onClick={downloadPDFFile}
        >
          {btnText}
        </Button>
      )}
      {!isDone && url && (
        <Link
          className={`btn btn-primary ml-sm-1 mt-hf mt-sm-0 ${style.onboarding__btn}`}
          to={url}
        >
          {btnText}
        </Link>
      )}
    </li>
  );
};

DrivingTestListItem.propTypes = {
  title: string.isRequired,
  btnText: string.isRequired,
  url: string,
  subtitle: oneOfType([string, node]),
  status: number,
  downloadPDFFile: func,
};

export default DrivingTestListItem;
